import React, { useState } from "react";
import Card from "../Card/Card";
import styled from "styled-components";
import theme from "../../theme/theme";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBookmark,
  faArrowAltCircleDown,
} from "@fortawesome/free-solid-svg-icons";
import educationIcon from "../../assets/educationIcon.jpg";
import retirementIcon from "../../assets/retirementIcon.jpg";
import majorPurchaseIcon from "../../assets/majorPurchaseIcon.jpg";
import buildWealthIcon from "../../assets/buildWealthIcon.jpg";
import EditButton from "../EditName/EditButton";
import EditNameModalScreen from "../EditName/EditNameModalScreen";

const Wrapper = styled.div`
  width: 100%;
  background-color: yellow;

  .cardContentParent {
    .headerRow {
      border-bottom: 1px solid lightgray;
      padding-bottom: 20px;
      display: flex;
      width: 100%;
      justify-content: space-between;
      flex-wrap: wrap;
      @media (max-width: 650px) {
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
      }

      .headerContainer {
        width: 50%;
        display: flex;
        white-space: nowrap;
        align-items: center;
        @media (max-width: 480px) {
          width: 100%;
          justify-content: space-between;
          white-space: normal;
          text-align: center;
        }
      }

      .icon {
        margin-right: 10px;
        height: 50px;
        @media (max-width: 480px) {
          margin: auto;
          margin-right: 5px;
        }
      }

      .goalImage {
        height: 100%;
      }

      .goalName {
        width: 40%;
        display: flex;
        align-items: center;
        @media (max-width: 480px) {
          width: 100%;
        }

        .name {
          font-size: 30px;
          color: ${theme.colors.primaryStrong2X};

          .goalTitle {
            max-width: 300px;
            overflow: hidden;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;

            @media (max-width: 480px) {
              width: 100%;
              max-width: 200px;
            }
            @media (max-width: 380px) {
              width: 100%;
              max-width: 150px;
            }
          }

          .date {
            font-size: 12px;
            margin-top: 8px;
          }
          //display: flex;
          //align-items: flex-end;
          //flex-wrap: nowrap;
        }

        .no {
          font-size: 15px;
          color: ${theme.colors.primaryStrong2X};
        }
      }

      .today {
        @media (max-width: 650px) {
          width: 100%;
        }

        .applicationStatusContainer {
          float: right;
          display: flex;
          gap: 30px;
          @media (max-width: 650px) {
            float: none;
            gap: 0px;
          }

          .balanceContainer {
            @media (max-width: 650px) {
              width: 50%;
            }
          }

          .todayContainer {
            @media (max-width: 650px) {
              width: 50%;
            }
          }
        }

        .amount {
          font-size: 30px;
          color: black;
          white-space: nowrap;
          text-align: center;
        }
        .text {
          font-size: 15px;
          color: ${theme.colors.primaryStrong2X};
          text-align: center;
        }
      }
    }

    .body {
      margin-top: 20px;
      padding: 0px 30px;
      display: flex;
      padding-bottom: 20px;
      border-bottom: 1px solid lightgray;
      @media (max-width: 480px) {
        padding: 0;
        width: 100%;
        justify-content: center;
        align-items: center;
      }

      & h4 {
        font-size: 12px;
        font-weight: 700;
        margin: 0;
      }
      .accountDetails {
        width: 50%;
        border-right: 1px solid lightgray;
        @media (max-width: 480px) {
          padding: 0;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin-bottom: 20px;
        }

        .info {
          color: ${theme.colors.primaryStrong2X};
          margin-top: 10px;
          font-size: 12px;
        }
      }

      .topHoldings {
        width: 50%;

        // border-right: 1px solid lightgray;
        padding-left: 30px;
        @media (max-width: 480px) {
          padding: 0;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin-bottom: 20px;
        }

        .info {
          color: ${theme.colors.primaryStrong2X};
          margin-top: 10px;
          font-size: 12px;
        }
      }

      .topHoldingsContainer {
        display: flex;
        flex-wrap: wrap;
        padding-left: 0;
        & li {
          list-style: none;
          flex: 0 0 50%;
          margin: 0;
          text-align: center;
          display: flex;
        }
        .topHoldingSymbol {
          color: ${theme.colors.primaryStrong2X};
          font-size: 12px;
          margin-top: 10px;
        }
        .topHoldingDescription {
          color: ${theme.colors.primaryStrong2X};
          font-size: 10px;
          margin-left: 10px;
        }
      }

      .viewStatement {
        width: 33%;
        padding-left: 30px;
      }
    }

    .footer {
      display: flex;
      width: 100%;
      margin-top: 20px;
      gap: 10px;

      .footerButton {
        width: 50%;
        border: none;
        padding: 20px 0px;
        border-radius: 15px;
        font-size: 20px;
        cursor: pointer;
        @media (max-width: 480px) {
          font-size: 16px;
          padding: 10px;
        }
      }
    }
  }
`;

const GoalCard = (props) => {
  const [isEditing, setIsEditing] = useState(false);
  return (
    <Wrapper>
      {isEditing && (
        <EditNameModalScreen
          id={props.data.goalId}
          isHidden={setIsEditing}
          actualName={props.data.goalTitle}
        />
      )}
      <Card isMarginNeeded={false} isLeftBorderVisible={true}>
        <div className="cardContentParent">
          <div className="headerRow">
            <div className="headerContainer">
              <div className="icon">
                <img
                  className="goalImage"
                  alt="goal type logo"
                  src={
                    props.data.goalType === "Education"
                      ? educationIcon
                      : props.data.goalType === "Retirement"
                      ? retirementIcon
                      : props.data.goalType === "Major Purchase"
                      ? majorPurchaseIcon
                      : props.data.goalType === "Build Wealth"
                      ? buildWealthIcon
                      : ""
                  }
                />
              </div>
              <div className="goalName">
                <div className="name">
                  <div className="goalTitle">
                    {props.data.goalTitle.length <= 19
                      ? props.data.goalTitle
                      : props.data.goalTitle.substring(0, 19) + "..."}
                  </div>{" "}
                  {/* <div className="date">
                    Created: {new Date(props.data.createdDate).toDateString()}
                  </div> */}
                </div>
                <EditButton
                  actionOnClick={() => {
                    setIsEditing(true);
                  }}
                  isMarginTopNeeded={false}
                />
                {/* <div className="no">XXXXXXXXXXX 08253</div> */}
              </div>
              <div className="balanceTodayContainer">
                {/* <div className="balance">
                <div className="amount">{props.data.balanceAsString || ""}</div>
                <div className="text">Balance</div>
              </div> */}
              </div>
            </div>
            <div className="today">
              <div className="applicationStatusContainer">
                <div className="balanceContainer">
                  <div className="amount">
                    {/* {props.data.dailyReturnAsString || ""} */}
                    {props.data.balanceAsString}
                  </div>
                  <div className="text">Balance</div>
                </div>
                <div className="todayContainer">
                  <div
                    className="amount"
                    style={{
                      color:
                        props.data.dailyReturn < 0
                          ? "red"
                          : Math.abs(props.data.dailyReturn) > 0
                          ? "green"
                          : "black",
                    }}
                  >
                    {/* {props.data.dailyReturnAsString || ""} */}
                    {props.data.dailyReturnAsString}
                  </div>
                  <div className="text">Today</div>
                </div>
              </div>
            </div>
          </div>
          <div className="body">
            <div className="accountDetails">
              <h4 className="heading">
                <FontAwesomeIcon icon={faArrowAltCircleDown} /> Account Details
              </h4>
              <ul>
                <li className="info">
                  Goal Type: {props?.data?.goalType || ""}{" "}
                </li>
                <li className="info">
                  Opened: {new Date(props.data.opened).toDateString()}{" "}
                </li>
              </ul>
            </div>
            <div className="topHoldings">
              <h4 className="heading">
                <FontAwesomeIcon icon={faBookmark} /> Top Holdings
              </h4>
              <div className="topHoldingsContainer">
                {/* {props?.data?.topHoldings.map((holding, index) => (
                  <>
                    <li className="info">
                      {index + 1}. {holding.symbol}
                    </li>
                  </>
                ))} */}
                <div style={{ width: "50%" }}>
                  <div className="topHoldingSymbol">
                    1 {props?.data?.topHoldings[0]?.symbol}
                  </div>
                  <div className="topHoldingDescription">
                    {props?.data?.topHoldings[0]?.description || " "}
                  </div>
                  <div className="topHoldingSymbol">
                    2 {props?.data?.topHoldings[1]?.symbol}
                  </div>
                  <div className="topHoldingDescription">
                    {props?.data?.topHoldings[1]?.description}
                  </div>
                  <div className="topHoldingSymbol">
                    3 {props?.data?.topHoldings[2]?.symbol}
                  </div>
                  <div className="topHoldingDescription">
                    {props?.data?.topHoldings[2]?.description}
                  </div>
                </div>
                <div>
                  <div className="topHoldingSymbol">
                    4 {props?.data?.topHoldings[3]?.symbol}
                  </div>
                  <div className="topHoldingDescription">
                    {props?.data?.topHoldings[3]?.description}
                  </div>
                  <div className="topHoldingSymbol">
                    5 {props?.data?.topHoldings[4]?.symbol}
                  </div>
                  <div className="topHoldingDescription">
                    {props?.data?.topHoldings[4]?.description}
                  </div>
                  <div className="topHoldingSymbol">
                    6 {props?.data?.topHoldings[5]?.symbol}
                  </div>
                  <div className="topHoldingDescription">
                    {props?.data?.topHoldings[5]?.description}
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="viewStatement">
              <div className="heading">
                <FontAwesomeIcon icon={faListAlt} /> View Statements
              </div>
            </div> */}
            <div></div>
            <div></div>
          </div>
          <div className="footer">
            <button
              className="footerButton"
              onClick={() => props.handleContactAdvisorClick(props.data.goalId)}
            >
              Contact Advisor
            </button>
            <button
              className="footerButton"
              onClick={() => props.manageAccountClick(props.data.goalId)}
            >
              Manage Account
            </button>
          </div>
        </div>
      </Card>
    </Wrapper>
  );
};

export default GoalCard;
